module.exports = __webpack_public_path__ + "img/ACCOUNTING.7dd634d9.svg";